import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAftBathingPlatform = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 94,
	height: 100,
	viewBox: "0 0 94 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M79.25 5.54692C78.425 5.82192 78 4.88592 78 2.79692C78 0.707922 78.425 -0.228078 79.25 0.0469215C79.938 0.275922 80.5 1.51392 80.5 2.79692C80.5 4.07992 79.938 5.31792 79.25 5.54692Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.071 8.79692C70.581 8.79692 67.928 5.72192 68.55 4.71592C69.32 3.47092 70.3641 3.56092 71.8 4.99692C73.222 6.41892 73.392 8.79692 72.071 8.79692Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.3781 8.79692C84.6811 8.79692 84.5789 6.61792 86.2 4.99692C87.6759 3.52092 88.682 3.47392 89.527 4.84092C90.334 6.14592 88.2231 8.79692 86.3781 8.79692Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0909 17.6619C28.7729 15.3019 28.798 14.7549 30.333 12.4119C33.327 7.84192 41 9.91692 41 15.2969C41 20.8719 32.8689 22.6349 30.0909 17.6619Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74 14.7969C74 13.3669 74.5399 11.6569 75.2 10.9969C75.86 10.3369 77.57 9.79692 79 9.79692C82.305 9.79692 84 11.4919 84 14.7969C84 18.1019 82.305 19.7969 79 19.7969C75.695 19.7969 74 18.1019 74 14.7969Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.083 15.7969C63.99 15.7969 62.91 14.4129 65.25 13.4479C67.182 12.6509 69.291 13.1659 69.75 14.5469C70.023 15.3669 69.105 15.7969 67.083 15.7969Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91 15.7969C87.979 15.7969 86.93 14.3959 89.25 13.4589C89.938 13.1819 90.576 12.9189 90.668 12.8759C90.761 12.8329 91.548 13.0699 92.418 13.4039C95.03 14.4059 94.206 15.7969 91 15.7969Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.98096 36.8329C10.628 33.7539 19.944 23.5329 22.423 22.0819C25.273 20.4159 25.169 20.3889 30.106 24.0979C32.523 25.9139 38.888 30.4359 44.25 34.1469C50.946 38.7819 54 41.5059 54 42.8459C54 46.1529 50.265 45.1429 41.093 39.3559C36.35 36.3629 31.7949 33.6559 30.9709 33.3399C29.9869 32.9619 27.648 34.8379 24.152 38.8109L18.83 44.8569L21.948 49.7159L25.066 54.5749L21.755 61.4359C19.318 66.4849 17.857 68.3809 16.222 68.6169C13.572 68.9979 13.569 68.9659 15.592 61.7539L17.184 56.0809L13.095 50.6889C8.57497 44.7269 7.21196 40.1379 8.98096 36.8329Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.041 25.3219C68.316 24.8739 68.313 24.0799 69.032 22.7359C70.223 20.5119 73 20.1189 73 22.1749C73 24.0219 70.348 26.1299 69.041 25.3219Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.636 24.2899C85.736 23.3899 85 22.2359 85 21.7259C85 20.2489 87.632 20.6489 89.035 22.3389C90.951 24.6479 88.768 26.4219 86.636 24.2899Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.25 29.5469C78.425 29.8219 78 28.8859 78 26.7969C78 24.7079 78.425 23.7719 79.25 24.0469C79.938 24.2759 80.5 25.5139 80.5 26.7969C80.5 28.0799 79.938 29.3179 79.25 29.5469Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 77.8489V74.7969V71.7449L15.25 72.0209L30.5 72.2969V74.7969V77.2969L15.25 77.5729L0 77.8489Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.69995 88.1699C-0.335049 86.1179 -0.324003 86.1299 0.421997 84.9239C0.822997 84.2739 2.26499 84.4279 4.48999 85.3569C8.92899 87.2119 11.371 87.1739 15.21 85.1879C18.069 83.7099 18.595 83.7099 21.694 85.1879C23.55 86.0729 25.937 86.7969 27 86.7969C28.063 86.7969 30.45 86.0729 32.306 85.1879C35.405 83.7099 35.931 83.7099 38.79 85.1879C42.67 87.1949 44.86 87.2129 48.756 85.2689C51.533 83.8839 52.214 83.8989 56.049 85.4329C59.9689 87.0019 60.597 87.0069 64.639 85.5089C68.673 84.0139 69.338 84.0179 73.505 85.5619C78.051 87.2469 78.273 87.2239 85.25 84.3129C86.487 83.7969 87 84.0469 87 85.1639C87 87.2089 81.971 89.7969 78 89.7969C76.295 89.7969 73.573 89.1099 71.95 88.2709C69.306 86.9039 68.694 86.9039 66.05 88.2709C62.303 90.2089 58.697 90.2089 54.95 88.2709C52.306 86.9039 51.694 86.9039 49.05 88.2709C45.299 90.2109 42.123 90.2039 38.2 88.2469C35.394 86.8469 34.8029 86.8469 32.0959 88.2469C30.4479 89.0999 28.155 89.7969 27 89.7969C25.845 89.7969 23.5521 89.0999 21.9041 88.2469C19.1971 86.8469 18.606 86.8469 15.8 88.2469C11.804 90.2399 7.72095 90.2139 3.69995 88.1699Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.29504 98.2159C2.74904 97.1609 0.479 95.7349 0.25 95.0469C-0.311 93.3629 1.58805 93.4739 6.69604 95.4249C10.635 96.9289 11.1489 96.9289 13.4449 95.4249C16.5559 93.3869 20.237 93.3509 24.05 95.3229C26.694 96.6899 27.306 96.6899 29.95 95.3229C33.778 93.3429 37.446 93.3879 40.597 95.4529C42.949 96.9929 43.3649 96.9929 46.5959 95.4529C50.9449 93.3789 53.271 93.3679 57.21 95.4059C60.069 96.8839 60.595 96.8839 63.694 95.4059C67.935 93.3829 70.291 93.3789 74.172 95.3859C76.98 96.8379 77.604 96.8379 81.406 95.3859C86.49 93.4439 87 93.4259 87 95.1879C87 96.4649 80.407 99.7969 77.881 99.7969C77.288 99.7969 75.216 99.0439 73.278 98.1239C70.24 96.6829 69.321 96.6349 66.626 97.7759C62.655 99.4579 59.3351 99.4539 55.3311 97.7599C52.5551 96.5859 51.6571 96.6479 48.0811 98.2599C44.1181 100.048 43.8819 100.048 39.9189 98.2599C36.3429 96.6479 35.4449 96.5859 32.6689 97.7599C30.9259 98.4969 28.375 99.0999 27 99.0999C25.625 99.0999 23.0741 98.4969 21.3311 97.7599C18.5521 96.5849 17.657 96.6479 14.043 98.2779C10.016 100.094 9.81904 100.092 5.29504 98.2159Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgAftBathingPlatform);
export { ForwardRef as ReactComponent };
